export default {
  payAll: "барлығы төлеу",
  payAFew: "кейбiр төлеу",
  pay: "төлеу",
  fyscalized: "салық салынды",
  nonFyscalized: "салық салынбаған",
  extendsFor: "созылдығ",
  duration: "узақтығы",
  months: "айы",
  all: "барлығы",
  fyscalization: "фискализация",
  drop: "алып тасу",
  activeBy: "белсендігi",
  remainderOnStorage: "Қоймадағы қалдық",
  remainder: "Қалдық",
  purchasePrice1: "Сатып алу бағасы",
  purchaseprice: "Сатып алу бағасы",
  salePrice1: "Сату бағасы",
  saleprice: "Сату бағасы",
  addPhotoes: "Фото қосыңыз",
  uploadPhotoes: "Фото жүктеу",
  "A network error (such as timeout, interrupted connenction or unreachable host) has occured":
    "Желілік қате орын алды (мысалы, күту уақыты, байланыс үзілген немесе хост қол жетімді емес)",
  // Login page
  login: "Кіру",
  Reports: "Есептер",
  addProduct: "Өнімді қосыңыз",
  "Add new product": "Жаңа өнімді қосыңыз",
  logout: "Шығу",
  forgetPassword: "Парольді ұмыттыңызба?",
  toRegister: "Тіркелу",
  UIN: "ЖСН",
  step: "Қадам",
  step1: "ЖСН нөміріңізді жазыңыз",
  step2:
    "Тіркеу кезінде жасаған парольді енгізіңіз. Егер парольіңізді ұмытып қалған болсаңыз, “Парольді ұмыттыңызба??” Опциясын таңдаңыз.",
  step3: "“Кіру” түймесін басыңыз",
  "Неверный логин и/или пароль!": "Қате логин немесе пароль!",
  registration: "Тіркелу",
  BIN: "БСИ",
  phoneNumber: "Телефон номері",
  back: "Артқа",
  next: "Алға",
  requiredField: "Міндетті түрде толтыру керек",
  enterEmail: "Email енгізіңіз",
  enterValidEmail: "Жарамды Email енгізіңіз",
  enterUINorBIN: "ЖСН/БСИ енгізіңіз",
  chooseTaxOrgan: "Салық органын таңдаңыз",
  UINLength: "ЖСН/БСИ 12 символдан болу керек",
  serieLength: "Серия 5 символ болу керек",
  VATLength: "ҚҚС номері 7 символ болу керек",
  enterPhone: "Телефон номер теріңіз",
  chooseTaxType: "Салықтың түрін таңдаңыз",
  onlyLatin: "Тек латын алфавиті болу керек  ",
  capitalizeRequired: "Кемі 1 бас әріп болу керек",
  numberRequired: "Кемі 1 сан болу керек",
  lengthSymbols: "Кемі 8 символ болу керек",
  repeatPassword: "Парольді қайталаңыз",
  passwordDontMatch: "Парольдер бірдей болу керек",
  // Profile page
  profilePage: "Жеке парақ",
  analyticsPage: "Аналитика",
  supplyPage: "Қалдықтар",
  discountPage: "Науқандар",
  purchasesPage: "Закупки",
  salesPage: "Сатылымдар",
  salesReportPage: "Сатылған тауарлар",
  selectStorePage: "Дүкендер",
  cashboxPage: "Кассалар",
  employeesPage: "Қызметкерлер",
  inventoriesPage: "Инвентаризация",
  inventoryPage: "Инвентаризация бетi",
  fullname: "Аты-жөні",
  legalAddress: "Заңды мекен-жайы",
  VAT: "ҚҚС",
  taxOrgan: "Салық органы",
  taxType: "Салық түрі",
  store: "дүкен",
  stores: "Дүкен(дер)",
  storeName: "Дүкен атауы",
  storeAddress: "Дүкен мекен-жайы",
  // AnalyticsPage
  dailyStatistic: "Күн статистикасы",
  today: "бүгін",
  yesterday: "кеше",
  chooseStore: "Дүкенді таңдаңыз",
  add: "Қосу",
  select: "Таңдау",
  change: "Өзгерту",
  delete: "Кетіру",
  cancel: "Қайтару",
  save: "Сақтау",
  sales: "Сатылымдар",
  profit: "Пайда",
  create: "Ашу",
  averageCheck: "орт. чек",
  order1: "тапсырыс",
  order2: "тапсырыс",
  order3: "тапсырыс",
  client1: "клиент",
  client2: "клиент",
  client3: "клиент",
  total: "Жалпы",
  numDays: "күнгі",
  month: "айға",
  numMonth: "айға",
  other: "Басқа",
  allSupplies: "Барлығы",
  barcode: "Штрих-код",
  supplyTitle: "Атауы",
  priceSale: "Сатылым\n бағасы, тг",
  priceSale2: "Сатылым бағасы",
  stock: "Қалдық",
  stockBalance: "Қоймадағы\nқалдық",
  searchWithBarcodeName: "Штрих-кодпен немесе атауымен іздеу",
  searchWithName: "Тауарды атауымен іздеу",
  pageWord: "бет",
  unitsMeasuring: "Өлшем бірлік",
  discount: "Науқан",
  datePurchase: "Сатып алынған уақыты",
  purchasesInfo: "Сатып алу туралы ақпарат",
  purchasePrice: "Сатып\nалынған бағасы, тг",
  title: "Атауы",
  amountProduct: "Тауарлар саны",
  from: "Бастап",
  to: "Дейін",
  discountPercent: "Жеңілдік, %",
  addDiscount: "Жеңілдік қосу",
  link: "сілтеме",
  forOperators: "операторлар үшін",
  employe: "Қызметкер",
  totalPrice: "Жалпы\nбағасы, тг",
  note: "Ескерту ",
  purchasesSum: "Жалпы\nсатып алынды",
  unitsMeasuringStorage: "Қоймадағы\nөлшем-бірлік",
  cashboxId: "Касса номері",
  saleId: "Сатылған номері",
  dateSale: "Сатылған күні",
  quantity: "Саны",
  price: "Бағасы, тг",
  fiscalize: "фискализациялау",
  nameCashbox: "Кассаның атауы",
  idCashbox: "Кассаның ID",
  titleStore: "Дүкен атауы",
  titelInventory: "Инвентаризация атауы",
  addressStore: "Дүкен мекен-жайы",
  state: "Жағдайы",
  fiscal: "Фискализация",
  cashboxInfo: "Касса туралы ақпарат",
  shiftInfo: "Ауысым туралы ақпарат",
  idNumber: "Сәйкестендіру номері",
  factoryNumber: "Сериялық нөмір",
  serialNumber: "Сериялық нөмір",
  cashboxDescription: "Кассаның сипаттамасы",
  description: "Сипаттамасы",
  AddingToCategory: "Категорияға қосу",
  AddToCategory: "Категорияға қосу",
  registrationNumber: "Тіркеу номері",
  dateRegister: "Тіркелу уасыты",
  wayEnterDiscount: "Науқанды жазу жолы",
  defaultIndustry: "Саланың түрі",
  purchaseMode: "'Cатып алу' режимі",
  markup: "Қосымша ақы",
  serviceCenter: "Қызмет көрсету орталығы",
  activationPackage: "Активация пакеті",
  modeOperation: "Жұмыс режимі",
  CRF: "ОФД",
  confirmCode: "Растау коды",
  switchedOn: "Қосулы",
  switchedff: "Өшірулі",
  isAbsent: "Жоқ",
  shiftNumber: "Ауысым номері",
  shiftOpening: "Ауысым ашылуы",
  cashOnHand: "Қолдағы ақша",
  numberOfSales: "Сатылым саны",
  returnSales: "Қолма-қол сатылым",
  cashSales: "Продаж наличными",
  cardSale: "Карталармен сатылым",
  numberOfPurchases: "Сатып алу саны",
  numberOfRefunds: "Қайтарылған сатып алу саны",
  deposit: "Салу",
  withdrawal: "Шығару",
  sum: "Сумма",
  numberOfDocuments: "Құжатар саны",
  shiftClosing: "Ауысымның жабылуы",
  roles: "Құқықтары",
  lastname: "Тегі",
  middlename: "Әкесінің аты",
  firstname: "Аты",
  sendPassword: "Пароль жіберу",
  startInventory: "Инвентаризацияны бастау",
  pastInventory: "Өткен инвентаризациялар",
  dateStart: "Басталу уақыты",
  disconnected: "Өшірулі",
  connected: "Қосулы",
  dateEnd: "Біткен уақыты ",
  show: "Көрсету",
  edit: "Өзгерту",
  toComplete: "Бітіру",
  discountToProduct: "Тауарға науқан",
  titleProduct: "Тауардың аты",
  saveChanges: "Өзгерістерді сақтау",
  createNewDiscount: "Жаңа науқан ашу",
  titleDiscount: "Науқанның атауы",
  product: "тауар",
  find: "Табу",
  enterProductName: "Тауардың атауын жазыңыз",
  addToDiscount: "Науқанға қосу",
  createDiscount: "Науқан ашу",
  createPromotionalItem: "Науқанды тауар ашу",
  confirmDelete: "Кетіруді растау",
  fiscalized: "Фискализация жасалды",
  notFiscalized: "Фискализация жасалмады",
  yes: "Ия",
  no: "Жоқ",
  enterStoreName: "Дүкеннің атауын енгізіңіз",
  selectStorage: "Дүкенді таңдаңыз",
  registerIdCashbox: "Кассаның тіркеу номері",
  dataChange: "Деректерді өзгерту",
  notFoundPage: "Сұралған бет табылмады",
  "In this section you can work with your cash registers, namely":
    "Бұл бөлімде сіз кассалық аппараттармен жұмыс жасай аласыз, атап айтқанда:",
  "Create new cash desks": "Жаңа кассалар жасай аласыз",
  "Delete existing cash desks": "Қолданыстағы кассаларды жою",
  "Edit Title": "Атауын өзгерту",
  "Turn on / off cash desks": "Кассаларды қосу / өшіру",
  "Fiscalize cash registers": "Кассалық машиналарды фискализациялау",
  "In this section you can create, modify and delete stocks of your stores":
    "Бұл бөлімде сіз өз дүкендеріңіздің қорларын құруға, өзгертуге және жоюға болады",
  "In this section you can": "Бұл бөлімде сіз:",
  "Add new employees to stores": "Дүкендерге жаңа қызметкерлерді қоса аласыз",
  "Remove employees from stores": "Қызметкерлерді дүкендерден шығара аласыз",
  "Edit employee access levels":
    "Қызметкерлерге кіру деңгейлерін өзгерте аласыз",
  "Please note that to add an employee, his / her IIN and cell phone number are required":
    "Қызметкерді қосу үшін оның ЖСН және ұялы телефон нөмірі қажет екенін ескеріңіз",
  "Conduct a new inventory": "Жаңа инвентаризация жасай аласыз",
  "View details of previous inventories":
    "Алдыңғы инвентаризациялардың толық мәліметтерін қарай аласыз",
  "Link copied": "Сілтеме көшірілді",
  "In the menu of a specific inventory you can":
    "Нақты инвентаризация мәзірінде сіз жасай аласыз:",
  "Complete inventory at the end of the inventory":
    "Инвентаризация біткен бойда аяқтай аласыз",
  "Delete inventory": "Инвентаризацияны кетіре аласыз",
  "Export inventory": "Инвентаризацияны экспорттай аласыз",
  "In this section you can see detailed information about the owner of this Smartkassa account":
    "Бұл бөлімде сіз осы Smartkassa аккаунтының иесі туралы толық ақпаратты көре аласыз.",
  Signature: "Қолы:",
  "Goods from the purchase": "Сатып алған тауарлар",
  "In this section you can observe the information on purchases, namely":
    "Бұл бөлімде сіз сатып алу туралы ақпаратты көре аласыз, дәлірек айтсақ:",
  "Date of purchase": "Сатып алу күні",
  "The cashier who procured": "Сатып алған кассир",
  "Total cost": "Жалпы құны",
  "Various purchase notes": "Сатып алу туралы әртүрлі жазбалар",
  "Click on the purchase you are interested in for more information":
    "Қосымша ақпарат алу үшін сізді қызықтыратын сатып алуды басыңыз.",
  "Password sent to the specified number":
    "Көрсетілген нөмірге пароль жіберілді!",
  "Incorrect code entered": "Қате код енгізілді",
  "Enter code": "Кодты енгізіңіз",
  "Password recovery": "Парольді қалпына келтіру",
  "Login/IIN": "Логин/ЖСН",
  "Enter the code sent to your number":
    "Сіздің номеріңізге жіберілген кодты енгізіңіз",
  "Confirm password": "Парольді растаңыз",
  "Enter the correct code": "Дұрыс кодты енгізіңіз",
  "In this section you can observe information on sales, namely":
    "Бұл бөлімде сіз сату туралы ақпаратты көре аласыз, дәлірек айтсақ:",
  "Date of sale": "Сату күні",
  "The cashier who conducted the sale": "Сатылым жүргізген кассиршы",
  "Various sales notes": "Сатылым туралы әртүрлі ескертпелер",
  "Click on the sale you are interested in for more information":
    "Қосымша ақпарат алу үшін сізді қызықтыратын сатылымды басыңыз.",
  "In this section you can observe detailed information about each sold product for a certain period, including":
    "Бұл бөлімде сіз белгілі бір мерзімдегі әрбір сатылған өнім туралы толық ақпаратты көре аласыз, соның ішінде:",
  "Unit of measure": "Тауардың өлшем бірлігі",
  "Total cost of goods": "Тауардың жалпы құны",
  "Unit of measure in stock": "Қоймадағы өлшем-бірлік",
  "Enter the correct password code": "Дұрыс пароль кодын енгізіңіз",
  "Choose a store, information about which you want to receive":
    "Ақпарат алғыңыз келетін дүкенді таңдаңыз",
  "Create new stores": "Жаңа дүкендер аша аласыз",
  "Edit store names and addresses":
    "Дүкендердің атын мекен-жайын өзгерте аласыз",
  "Delete existing stores": "Бар дүкендерді жоя аласыз",
  "Shop Creation": "Дүкен ашу",
  "Select Storage Shop creation step 1 info":
    "Дүкеннің аты мен мекенжайын орнатыңыз. Сіз белгілі бір сауда нүктесінің атауын көрсеткеніңізді ескеріңіз (кейінірек оны өзгертуге болады). Мекен-жай салық органында тіркеу кезінде берілген мекен-жайға сәйкес келуі керек",
  "The address must match the address issued during registration with the tax authority":
    "Мекен-жай салық органында тіркеу кезінде берілген мекен-жайға сәйкес келуі керек",
  "Cash desk creation": "Касса ашу",
  "Creation of the first cash desk Name the cashier and select the store in which it is located":
    "Алғашқы кассаны құру. Кассаны атаңыз және ол орналасқан дүкенді таңдаңыз",
  "Cashbox name": "Кассаның атауы",
  "Fiscalize cashbox": "Кассаны фискализациялау",
  "Please note that if you have a physical cashier, you can Smartkassa in non-fiscal mode by printing checks through your physical cashier":
    "Егер сізде физикалық кассир болса, сіз өзіңіздің жеке кассиріңіз арқылы чекті басып шығару арқылы Smartkassa-ны қаржылық емес режимде жасай алатындығыңызға назар аударыңыз.",
  "Prerequisites for Fiscalization":
    "Фискализация жасауға үшін қойылатын талаптар:",
  "cash register must be registered with the tax authority":
    "Касса машинасы салық органында тіркелуі керек",
  "account on the Webkassa service (paid separately on the website wwwwebkassakz)":
    "Webkassa сервисіндегі есептік жазба (www.webkassa.kz сайтында бөлек төленеді)",
  "CRF account (paid separately on the website wwwoofdkz)":
    "ОФД аккаунты (www.oofd.kz сайтында бөлек төленеді)",
  "To Fiscalize": "Фискализациялау",
  skip: "Өткізу",
  "Create employee": "Қызметкер ашу",
  "To register an employee, you need:":
    "Қызметкерді тіркеу үшін сізге міндетті:",
  "IIN employee and": "Қызметкер ЖСН  және",
  "employee's cell phone number This number will receive the employee password to log into the Smartkassa system":
    "қызметкердің ұялы телефон нөмірі. Бұл нөмір Smartkassa жүйесіне кіру үшін қызметкердің паролін алады.",
  "Submit Code": "Код жіберу",
  "Password was sent to the specified number":
    "Пароль көрсетілген нөмірге жіберілді",
  "In this section you can observe detailed information for each of the goods you have, namely":
    "Бұл бөлімде сіз кез-келген тауар туралы толық ақпаратты көре аласыз, атап айтқанда:",
  "Purchase price": "Сатып алу бағасы",
  "The total cost of the sale of goods": "Сатудың жалпы құны",
  "Setted discount": "Орнатылған жеңілдіу",
  "Click on a product for more information":
    "Толығырақ ақпарат алу үшін тауарға басыңыз",
  "Once you have added the stocks, add the good ones and click on the 'Add to stocks' item below":
    "Науқанға өнімді қосу үшін, қалаған өнімді таңдап, «Науқанға қосу» түймесін басыңыз, содан кейін қажетті жарнаманы таңдаңыз немесе жаңасын жасаңыз.",
  "": "",
  "Data not found": "Деректер табылмады",
  "In storage": "Қоймада:",
  new1: "Жаңа:",
  new2: "Жаңа:",
  new3: "Жаңа:",
  unitsMeasuringFull: "Өлшем бірлік:",
  purchasePrice2: "Цена закупа: ",
  addUnitsMeasuring: "Өлшем бірлік қосу",
  selectUnitsMeasuring: "Өлшем бірлікті таңдаңыз",
  select2: "Таңдаңыз",
  purchased: "Сатып алынды",
  value: "Мәні",
  clear: "Тазалау",
  apply: "Қолдану",
  "To add a filter, press Enter, then Apply":
    "Фильтр қолдану үшін Enter пернесін, сосын Қолдану пәрменін таңдаңыз",
  "In this section you can observe information on purchases, sales and profits of a particular store or product":
    "Бұл бөлімде сіз белгілі бір дүкеннің немесе өнімді сатып алу, сату және пайда туралы ақпаратты көре аласыз.",
  redirectInventory: "Инвентаризацияға бетi",
  "Export to Excel": "Excel-ге экспорттау",
  "New inventory": "Жаңа инвентаризация",
  years: "жылдар",
  weeks: "апталар",
  "select week": "апталар тандау",
  "select dates": "күндер тандау",
  year: "жыл",
  checkNum: "Чек номiрi",
  AddChartToCompare: "салыстыру үшін график қосыңыз",
  AddComparableChart: "салыстырылатын график қосыңыз",
  "Comparative graph for time periods of different lengths":
    "Әр түрлі ұзындықтағы уақыт кезеңдерінің салыстырмалы графигі",
  "Comparative Line Chart": "Салыстырмалы сызба",
  January: "Қаңтар",
  February: "Ақпан",
  March: "Наурыз",
  April: "Сәуір",
  May: "Мамыр",
  June: "Маусым",
  July: "Шілде",
  August: "Тамыз",
  September: "Қыркүйек",
  October: "Қазан",
  November: "Қараша",
  December: "Желтоқсан",
  Monday: "Дүйсенбі",
  Tuesday: "Сейсенбі",
  Wednesday: "Сәрсенбі",
  Thursday: "Бейсенбі",
  Friday: "Жұма",
  Saturday: "Сенбі",
  Sunday: "Жексенбі",
  "Trade negative": "Сауда теріс",
  name: "аты",
  nds: "ҚҚС",
  accountInormation: "Жазба туралы мәліметтер",
  companyInformation: "Компания туралы ақпаратs",
  dataOnAvailableStores: "Қол жетімді дүкендер туралы мәліметтер",
  organization: "Организация",
  Login: "Логин",
  password: "пароль",
  "Old password": "Ескi парольдi жазыныз",
  "New password": "Жаңа парольдi жазыныз",
  "Repeat new password": "Жаңа парольді қайталаңыз",
  "Change password": "Парольдi ауыстыру",
  "Data loading": "Деректерді жүктеу",
  Inventory: "Инвентаризация",
}
